import { styled } from "@mui/material/styles";

export const Destination = styled("h3", {
  label: "destination",
})`
  font-weight: 500;
  font-size: 46px;
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.primary.main};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 30px;
  }
`;

export const DestinationMore = styled("span", {
  label: "destination-more",
})`
  font-size: 16px;
  white-space: nowrap;
  margin-left: ${({ theme }) => theme.spacing(0.75)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 20px;
  }
`;
